<template>
    <div id="app">
        <div id="background-image"></div>
        <app-navigation></app-navigation>
        <key-events></key-events>
        <transition name="fade">
            <template v-if="loading">
                <div class="loading">
                    <div class="loading__spinner">
                        <div class="loading__bounce1"></div>
                        <div class="loading__bounce2"></div>
                        <div class="loading__bounce3"></div>
                    </div>
                </div>
            </template>
        </transition>
        <transition :name="transitionName">
            <router-view class="view"></router-view>
        </transition>
    </div>
</template>

<script>
    import Navigation from './components/Navigation.vue';
    import {EventBus} from './lib/EventBus';
    import KeyEvents from './components/KeyEvents.vue';

    export default {
        name: 'app',
        components: {
            appNavigation: Navigation,
            keyEvents: KeyEvents
        },
        data() {
            return {
                transitionName: 'fade',
                loading: false
            }
        },
        methods: {

        },
        mounted () {

        },
    }
</script>




// WEBPACK FOOTER //
// App.vue?461d03e2